import { Component, OnInit, inject, OnChanges, SimpleChanges } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subscription, map, shareReplay } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { MenuCategory } from '../model/menuItem.model';
import { Profile } from 'src/app/shared/model/profile.model';
import { UserProfileService } from 'src/app/shared/services/user-profile.service';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { LayoutService } from '../service/layout.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { clearStaleMsalInteraction } from 'src/app/modules/auth/msal-interaction.util';

export interface NavItem {
  displayName: string;
  disabled?: boolean;
  iconName: string;
  route?: string;
  children?: NavItem[];
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, OnChanges {
  private apiCallSubscription!: Subscription;
  private subscription!: Subscription;

  menuCategory: MenuCategory[] = [];
  profileInfo?: Profile;
  userInfo?: any;
  apiCallTrigger = false;
  uniqueData: any;
  // panelOpenState = false;
  // openSidebar: boolean = true;
  private breakpointObserver = inject(BreakpointObserver);
  constructor(
    private authService: MsalService,
    private profileSerive: UserProfileService,
    private layoutService: LayoutService,
    private _snackBar: MatSnackBar,
    private apiService: SharedDataService
  ) {
    console.log('================================ ahsan');
  }

  ngOnChanges(changes: SimpleChanges): void {
    // throw new Error('Method not implemented.');
    debugger;
    let userInfo: any = localStorage.getItem('user-information');
    if (userInfo) {
      this.userInfo = JSON.parse(userInfo);
    }

    let profile = localStorage.getItem('profileInfo');
    if (profile) {
      this.profileInfo = JSON.parse(profile);
    }
  }


  ngOnInit(): void {
    // this.apiService.setApiCallTrigger(true);
    const storedMenu = localStorage.getItem('menuData');
    if (storedMenu) {
      this.menuCategory = JSON.parse(storedMenu);
    }
    this.apiCallSubscription = this.apiService
      .getApiCallTrigger()
      .subscribe((value) => {
        this.apiCallTrigger = value;
        console.log('apiCallTrigger', this.apiCallTrigger);
        if (this.apiCallTrigger) {
          this.getMenu();
          console.log('');
          const storedMenu = localStorage.getItem('menuData');
          if (storedMenu) {
            this.menuCategory = JSON.parse(storedMenu);
          }
        }
      });

    this.subscription = this.profileSerive
      .getProfile()
      .subscribe((response) => {
        if (response) {
          this.profileInfo = response;
          localStorage.setItem('profileInfo', JSON.stringify(this.profileInfo));
          let userInfo: any = localStorage.getItem('user-information');
          this.userInfo = JSON.parse(userInfo);
          if (userInfo) {
            if (this.profileInfo.mail) {
              userInfo = JSON.parse(userInfo);
              userInfo['emailAddress'] = this.profileInfo.mail;
              localStorage.setItem('user-information', JSON.stringify(userInfo));
            }
          }
        }
      });

    let userInfo: any = localStorage.getItem('user-information');
    if (userInfo) {
      this.userInfo = JSON.parse(userInfo);
    }

    let profile = localStorage.getItem('profileInfo');
    if (profile) {
      this.profileInfo = JSON.parse(profile);
    }
  }

  getMenu() {
    this.layoutService.getUserMenu().subscribe({
      next: (response) => {
        const uniqueFeatures: { [key: string]: any[] } = {};
        // Iterate throu gh the featurecollection
        if (
          response.data &&
          response.data.featurecollection &&
          response.data.featurecollection.length == 0
        ) {
          this._snackBar.open(
            'You do not have any roles assigned to this user.',
            'Close',
            {
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
              duration: 5000,
            }
          );
          setTimeout(() => {
            this.logoutSSO();
          }, 500);
        }
        for (const category of response.data.featurecollection) {
          const category_name = category.featureCategoryName;
          uniqueFeatures[category_name] = [];

          for (const feature of category.features) {
            const feature_name = feature.featureName;
            const feature_url = feature.featureUrl;

            // Check if the feature is unique
            if (
              !uniqueFeatures[category_name].some(
                (item) =>
                  item.featureName === feature_name &&
                  item.featureUrl === feature_url
              )
            ) {
              uniqueFeatures[category_name].push({
                featureName: feature_name,
                featureUrl: feature_url,
              });
            }
          }
        }

        // Create a new featurecollection with unique features
        this.uniqueData = [];

        for (const category_name in uniqueFeatures) {
          if (uniqueFeatures.hasOwnProperty(category_name)) {
            const features = uniqueFeatures[category_name];
            const category_data = {
              featureCategoryName: category_name,
              features: features,
            };
            this.uniqueData.push(category_data);
          }
        }

        // const shortName = response.data.displayname.match(/(^\S\S?|\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase();
        // this.profileInfo = { 'displayName': response.data.displayname, "email": response.data.email, "userName": response.data.username, 'shortName': shortName }
        // localStorage.setItem('menuData', JSON.stringify(this.uniqueData.reverse()));
        localStorage.setItem('menuData', JSON.stringify(this.uniqueData));
        // localStorage.setItem('userInfo', JSON.stringify(this.profileInfo));
      },
      error: (error) => {
        console.error('Error fetching menu data:', error);
      },
      complete: () => {
        const storedMenu = localStorage.getItem('menuData');
        if (storedMenu) {
          this.menuCategory = JSON.parse(storedMenu);
        }
      },
    });
  }

  menu: NavItem[] = [
    {
      displayName: 'Administrator',
      iconName: 'icon-note-add',
      children: [
        {
          displayName: 'Assign Feature',
          iconName: '',
          route: '/assign-feature-role',
        },
        {
          displayName: 'Features List',
          iconName: '',
          route: '/features',
        },
        {
          displayName: 'Feature Category',
          iconName: '',
          route: '/features/feature-category',
        },
        {
          displayName: 'User Role',
          iconName: '',
          route: '/features/feature-role',
        },
      ],
    },
    {
      displayName: 'User Control',
      iconName: 'icon-buy-crypto',
      children: [
        {
          displayName: 'Grade',
          iconName: '',
          route: '/grade/',
        },
        {
          displayName: 'Tobacco Type',
          iconName: '',
          route: '/tobacco/',
        },
        {
          displayName: 'Bank Details',
          iconName: '',
          route: '/bank-details/',
        },
        {
          displayName: 'Location',
          iconName: '',
          route: '/location/',
        },
        {
          displayName: 'Payment Type',
          iconName: '',
          route: '/payment-type/',
        },
        {
          displayName: 'Branch Details',
          iconName: '',
          route: '/bank-branch/',
        },
        {
          displayName: 'Farmer Status',
          iconName: '',
          route: '/farmer-status/',
        },
        {
          displayName: 'Area',
          iconName: '',
          route: '/area/',
        },
        {
          displayName: 'Sector',
          iconName: '',
          route: '/sector/',
        },
        {
          displayName: 'Village',
          iconName: '',
          route: '/village/',
        },
        {
          displayName: 'Mahal',
          iconName: '',
          route: '/mahal/',
        },
        {
          displayName: 'Generic Deduction',
          iconName: '',
          route: '/generic-deduction/',
        },
        {
          displayName: 'Miscellaneous Incentive',
          iconName: '',
          route: '/generic-incentive/',
        },
        {
          displayName: 'Generic Flag',
          iconName: '',
          route: '/generic-flag/',
        },
        {
          displayName: 'Department',
          iconName: '',
          route: '/department/',
        },
        {
          displayName: 'Buyer',
          iconName: '',
          route: '/buyer/',
        },
        {
          displayName: 'Buying Center',
          iconName: '',
          route: '/buying-center/',
        },
        {
          displayName: 'Quota',
          iconName: '',
          route: '/quota/',
        },
        {
          displayName: 'Grade Wise Year',
          iconName: '',
          route: '/grade-year/',
        },
        {
          displayName: 'Location Wise Deduction',
          iconName: '',
          route: '/deduction-location/',
        },
        {
          displayName: 'Location Wise Incentive',
          iconName: '',
          route: '/incentive-location/',
        },
        {
          displayName: 'Location Wise Flags',
          iconName: '',
          route: '/flags-location/',
        },
        {
          displayName: 'Farmer Data',
          iconName: '',
          route: '/farmer-data/',
        },
        {
          displayName: 'NTRM',
          iconName: '',
          route: '/ntrm',
        },
        {
          displayName: 'CPA',
          iconName: '',
          route: '/cpa',
        },
        {
          displayName: 'Nominee',
          iconName: '',
          route: '/nominee',
        },
      ],
    },
    {
      displayName: 'App Configuration',
      iconName: 'icon-note-add',
      children: [
        {
          displayName: 'Config Listing',
          iconName: '',
          route: '/app-config',
        },
      ],
    },
    {
      displayName: 'GLT Sieve Analysis',
      iconName: 'icon-note-add',
      children: [
        {
          displayName: 'Daily Set-up',
          iconName: '',
          route: '/qa-daily-setup',
        },
      ],
    },
    {
      displayName: 'BOM Creation',
      iconName: 'icon-note-add',
      children: [
        {
          displayName: 'New Pack Grade',
          iconName: '',
          route: '/add-new-pack-grade/',
        },
        {
          displayName: 'Components Internal Grade',
          iconName: '',
          route: '/add-components-internal-grade/',
        },
        {
          displayName: 'Blend Maintenance Ratio',
          iconName: '',
          route: '/blend-maintenance-ratio',
        },
      ],
    },
  ];

  // logoutSSO() {
  //   localStorage.clear();
  //   this.authService.logoutPopup({
  //     mainWindowRedirectUri: '/',
  //   });
  // }


  logoutSSO() {
    // MSAL keeps its own accounts and tokens in localStorage, so clearing it up front
    // would leave logoutPopup without an account to sign out and strand the popup.
    const account =
      this.authService.instance.getActiveAccount() ||
      this.authService.instance.getAllAccounts()[0] ||
      undefined;

    this.authService.logoutPopup({ account }).subscribe({
      next: () => this.completeLogout(),
      error: (err) => {
        console.error('Logout error', err);
        this.completeLogout();
      },
    });
  }

  private completeLogout() {
    localStorage.clear();
    clearStaleMsalInteraction();
    window.location.replace('/login');
  }



  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.apiCallSubscription.unsubscribe();
  }
}
